import Storage from './Storage';

/**
 * Store ClientFilters
 * 
 */
class ClientFilters extends Storage {
    storeName = 'client_filters_';

    /**
     * ClientFilters constructor
     * 
     * @param {string} id client id
     */
     constructor(id) {
        super();
        this.id = id;
        this.setKey();
    }

}

export default ClientFilters;